<template>
  <div class="side">
    <ul>
      <li>
        <a href="tel:18668284666">
          <div class="sidebox">
            <img src="img/side_icon02.png" />
            18668284666
          </div>
        </a>
      </li>
      <li>
        <a href="https://qiye.aliyun.com/" target="_blank">
          <div class="sidebox side3">
            <img src="img/email.png" />{{$t('head').rightside}}
          </div>
        </a>
      </li>
      <li>
        <a href="http://wpa.qq.com/msgrd?v=3&uin=3349632241&site=qq&menu=yes" target="_blank">
          <div class="sidebox side2">
            <img src="img/qq.png" />QQ
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "right",
};
</script>

<style scoped>
@media screen and (max-width: 1000px) {
  .side {
    /* display: none !important; */
    top: 200px;
  }
}
</style>
